import React, { createRef, useRef } from 'react'
import { Trans } from 'next-i18next'
import styled from 'styled-components'
import { Text } from '@machobear/design-system'

import { breakpoints } from '@/styles'
import Skeleton from '@/components/skeleton'

import PoiListItem from './poi-list-item'

type Props = {
  points: any
  setCurrentPoint: any
  activeId: number | null
  setActiveId: (id: number | null) => void
  currentTab: any
  isLoading: boolean
}

const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 350px;
  height: 350px;
  overflow-y: auto;

  ::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  @media only screen and (max-width: ${breakpoints.phoneMax}) {
    width: 100%;
  }
`

const PoiList = ({
  points,
  setCurrentPoint,
  activeId,
  setActiveId,
  currentTab,
  isLoading
}: Props) => {
  const ref = useRef(null)
  const handleClick = (id: number) => {
    setActiveId(id)
  }

  const refs = points?.reduce((acc: any, _value: any, index: number) => {
    acc[index] = createRef()
    return acc
  }, [])

  const getTabType = (currentTab: number) => {
    switch (currentTab) {
      case 0:
        return 'transit options'
      case 1:
        return 'schools'
      case 2:
        return 'grocery stores'
      case 3:
        return 'cafes'
      case 4:
        return 'restaurants'
      case 5:
        return 'parks'
      case 6:
        return 'shops'

      default:
        return 'points of interest'
    }
  }

  return (
    <ListWrapper ref={ref}>
      {isLoading ? (
        <>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 10,
              padding: '28px 12px 20px 12px'
            }}
          >
            <Skeleton width={350} height={20} />
            <Skeleton height={30} />
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 10,
              padding: '28px 12px 20px 12px'
            }}
          >
            <Skeleton width={350} height={20} />
            <Skeleton height={30} />
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 10,
              padding: '28px 12px 20px 12px'
            }}
          >
            <Skeleton width={350} height={20} />
            <Skeleton height={30} />
          </div>
        </>
      ) : points?.length > 0 ? (
        points?.map((point: any, index: number) => {
          return (
            <PoiListItem
              key={index}
              id={index}
              point={point}
              isActive={activeId === index ? true : false}
              setIsActive={handleClick}
              setCurrentPoint={setCurrentPoint}
              ref={refs[index]}
              parentRef={ref}
            />
          )
        })
      ) : (
        <Text weight="medium">
          <Trans i18nKey="'poi:b.listings.poi.no_nearby'">
            There are no {getTabType(currentTab)} nearby
          </Trans>
        </Text>
      )}
    </ListWrapper>
  )
}

export default PoiList
